import React, { useState } from "react";
import { X } from "lucide-react";

import { IconButton } from "@/shared/components/ui-kit";
import { tokensOf } from "./editing";

/* Emails and @domains as tokens in one box — the one email-or-domain input of the Policies
   screen, for a condition and for Visibility's invites. Enter, a space or a comma adds what
   was typed, Backspace in the empty field takes the last one off, and leaving the field keeps
   what was typed. Each token is removed by its own ×. */
export function TokenList({ items, onChange, label }: {
  items: string[];
  onChange: (items: string[]) => void;
  label: string;
}) {
  const [draft, setDraft] = useState("");
  const commit = (typed: string) => {
    const added = tokensOf(typed).filter((t) => !items.includes(t));
    setDraft("");
    if (added.length) onChange([...items, ...added]);
  };
  return (
    <div className="min-h-9 p-[3px] rounded-[10px] ring-1 ring-[var(--hairline-strong)] focus-within:ring-[var(--hairline-focus)] flex flex-wrap items-center gap-1">
      {items.map((item) => (
        <span key={item} className="max-w-full inline-flex items-center gap-1.5 h-7 pl-2.5 pr-1 rounded-[7px] bg-[var(--surface)] ring-1 ring-[var(--hairline)] text-[12px] text-[var(--text-secondary)]">
          <span className="min-w-0 truncate">{item}</span>
          <IconButton
            type="button"
            size="xs"
            aria-label={`Remove ${item}`}
            title={`Remove ${item}`}
            onClick={() => onChange(items.filter((i) => i !== item))}
          >
            <X className="w-3 h-3" strokeWidth={2} />
          </IconButton>
        </span>
      ))}
      <input
        aria-label={label}
        value={draft}
        placeholder={items.length ? "Add another" : "asha@acme.com or @acme.com"}
        onChange={(e) => {
          const typed = e.target.value;
          if (/[\s,]$/.test(typed)) commit(typed);
          else setDraft(typed);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            commit(draft);
          } else if (e.key === "Backspace" && !draft && items.length) {
            onChange(items.slice(0, -1));
          }
        }}
        onBlur={() => draft.trim() && commit(draft)}
        className="flex-[1_1_140px] min-w-[120px] h-7 px-2 bg-transparent outline-none text-[13px] text-[var(--text-primary)] placeholder:text-[var(--text-quaternary)]"
      />
    </div>
  );
}
